
// Create Title
const createTitle = (val) => {
  return val ? `${val} :: Wheel Freedom` : `Wheel Freedom`;
}

export default {
  createTitle
}